import React, { FC, useMemo } from 'react';

import { EVINCED_SEVERITIES, SORT_ORDER } from '@evinced-private/ui-common';

import { CustomSeverityNames, resolveSeverityLabel } from '../../helpers/SeverityLabelHelper';
import { IssueSeverities } from '../../interfaces/IssuesOverviewResponse';
import { sortBySeverity } from '../../services/severities/SeverityService';
import { ChartWrapper } from '../data-displays/overview-charts/chart-wrapper/ChartWrapper';

import { EvincedAdvantageBar } from './bars/EvincedAdvantageBarV2';

interface EvincedAdvantageProps {
	totalIssues: number;
	severitiesData: IssueSeverities[];
	customSeverityNames?: CustomSeverityNames;
}

const EvincedAdvantageChartV3: FC<EvincedAdvantageProps> = ({
	totalIssues,
	severitiesData,
	customSeverityNames = {}
}) => {
	const orderedSeveritiesData = useMemo(() => {
		return severitiesData?.sort((a, b) => sortBySeverity(a.severity, b.severity, SORT_ORDER.DESC));
	}, [severitiesData]);

	const criticalLabel = resolveSeverityLabel(EVINCED_SEVERITIES.CRITICAL, customSeverityNames);

	if (totalIssues === 0) {
		return null;
	}

	return (
		<ChartWrapper
			title={`Evinced advantage: auto detection of ${criticalLabel.toLowerCase()} issues chart`}
			className="avoid-break"
		>
			<EvincedAdvantageBar
				severitiesData={orderedSeveritiesData}
				totalCriticalIssues={totalIssues}
				customSeverityNames={customSeverityNames}
			/>
		</ChartWrapper>
	);
};

export { EvincedAdvantageChartV3 };
